import * as Yup from 'yup'

// admin sign in
export const SignInInitaialValue = {
  email: "",
  password: "",
  checkbox: false
}

export const SignInValidationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
  password: Yup.string().required("Password is required").min(8, 'Password should be minimum 8 character'),
  // checkbox:Yup.bool().oneOf([true], 'must be checked').required()
})


export const forgetPasswordIntial = {
  email: "",
  otp: undefined
}

export const forgetPasswordSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
  otp: Yup.number("Otp should be number").required("Otp is required"),
})

export const adminInitial = {
  email: "",
  password: ""
}

export const adminValidationSchema = Yup.object({
  email: Yup.string().email().required('Email is required'),
  password: Yup.string().required("Password is required")
  // .min(8, 'Password should be minimum 8 character'),
})

export const profileInitialValue = Yup.object({

  firstName: "",
  lastName: "",
  profilePic: ""
})


export const rideInitialValue = {
  // vehicleId:"",
  make: "",
  model: "",
  type: "",
  standardPrice: "",
  peakHourPrice: "",
  category: ""
}

export const rideValidationSchema = Yup.object().shape({
  // vehicleId: Yup.string().trim().required('Vehicle is required'),
  make: Yup.string().trim().required('Make is required'),
  model: Yup.string().trim().required('Model is required'),
  type: Yup.string().trim().required('Type is required'),
  standardPrice: Yup.number("Standard Price must be number.").required('Standard Price is required'),
  peakHourPrice: Yup.number("Peak Hour Price must be number.").required('Peak Hour Price is required'),
  category: Yup.string().trim().required('Category is required'),
});

export const addCategoryInitialValue = {
  category: [],
  cityId: [],
  countryId: "",
}

export const addCategoryValidationSchema = Yup.object().shape({
  countryId: Yup.mixed().required('country is required'),

  cityId: Yup.array()
    .of(Yup.object().shape({
      label: Yup.string().required('City is required'),
      value: Yup.string().required('City is required'),
    }))
    .min(1, 'At least one city is required')
    .required('City is required'),

  category: Yup.array()
    .of(Yup.object().shape({
      label: Yup.string().required('Category is required'),
      value: Yup.string().required('Category is required'),
    }))
    .min(1, 'At least one city is required')
    .required('City is required'),

})

export const categoryInitialValue = {
  image: "",
  category: "",
  baseRate: "",
  perMiles: "",
  perMinute: "",
  longPickUpFee: "",
  surcharge: 0,
  rideBookingFee: "",
  waitFee: "",
  cancellationFee: "",
  platformFee: "",
  otherStopFee: "",
  cityId: "",
  countryId: "",
  cityTax: "",
  weather: "",
  licenceRegistrationAndInsurance: false,
  // promotionalDiscountFee:0,
  isFlash: false,
  isCommission: false,
  isSubscription: false,
  isWeather: false,
  minimumFare: 0,
  minDriverWalletBalance: 0,
  subscriptionFee: 0,
  commissionFee: 0,
  city: {},
  country: {},
  taxType: "City Tax",
  description: "",
  airportPickupFee: '',
  airportDropFee: '',
  order: "",
  fleetCommission: ""
}

export const categoryValidationSchema = Yup.object().shape({
  category: Yup.string().trim().required('Category is required'),

  baseRate: Yup.number()
    .typeError('Base rate must be a number')
    .positive('Base rate must be a positive number')
    .required('Base rate is required'),

  perMiles: Yup.number()
    .typeError('Per Km must be a number')
    .positive('Per Km must be a positive number')
    .required('Per Km is required'),

  perMinute: Yup.number()
    .typeError('Per minute must be a number')
    .positive('Per minute must be a positive number')
    .required('Per minute is required'),

  surcharge: Yup.number()
    .typeError('Surcharge must be a number')
    .required('Surcharge is required'),

  taxType: Yup.string()
    .required('Tax type is required'),

  rideBookingFee: Yup.number()
    .typeError('Ride booking fee must be a number')
    .positive('Ride booking fee must be a positive number')
    .required('Ride booking fee is required'),

  waitFee: Yup.number()
    .typeError('Wait fee must be a number')
    .positive('Wait fee must be a positive number')
    .required('Wait fee is required'),

  cancellationFee: Yup.number()
    .typeError('Cancellation fee must be a number')
    .positive('Cancellation fee must be a positive number')
    .required('Cancellation fee is required'),

  platformFee: Yup.number()
    .typeError('Platform fee must be a number')
    .positive('Platform fee must be a positive number')
    .required('Platform fee is required'),

  cityId: Yup.mixed().required('city is required'),
  countryId: Yup.mixed().required('country is required'),

  otherStopFee: Yup.number()
    .typeError('Other stop fee must be a number')
    .positive('Other stop fee must be a positive number')
    .required('Other stop fee is required'),

  cityTax: Yup.number()
    .typeError('City Tax(%)/ Levy Fee must be a number')
    .min(0, 'City Tax(%)/ Levy Fee must be a positive number or zero')
    .required('City Tax(%)/ Levy Fee is required'),

  weather: Yup.number()
    .typeError('Weather must be a number')
    .positive('Weather must be a positive number')
    .min(0, 'Number of rides must be a positive number or zero')
    .required('Weather is required'),
  // LicenceRegistrationAndInsurance: Yup.number()
  //   .typeError('Licence Registration and Insurance must be a number')
  //   .positive('Licence Registration and Insurance must be a positive number')
  //   .required('Licence Registration and Insurance is required'),

  minimumFare: Yup.number()
    .typeError('Minimum fare must be a number')
    .positive('Minimum fare must be a positive number')
    .required('Minimum fare fee is required')
    .min(0, 'Number of rides must be a positive number or zero'),

  minDriverWalletBalance: Yup.number()
    .typeError('Min wallet amount fee must be a number')
    .positive('Min wallet amount fee must be a positive number')
    .required('Min wallet amount fee is required')
    .min(0, 'Min wallet amount must be a positive number or zero'),

  subscriptionFee: Yup.number()
    .typeError('Subscription fee must be a number')
    .positive('Subscription fee must be a positive number')
    .required('Subscription fee is required')
    .min(0, 'Subscription fee must be a positive number or zero'),

  commissionFee: Yup.number()
    .typeError('Commission fee must be a number')
    .positive('Commission fee must be a positive number')
    .required('Commission fee is required')
    .min(0, 'Commission fee must be a positive number or zero'),

  isFlash: Yup.boolean(),

  // noOfRides: Yup.number()
  //   .typeError('Number of rides must be a number')
  //   .integer('Number of rides must be an integer'),

  isCommission: Yup.boolean().test('isCommission', 'At least one of Commission or Subscription must be true', function (value) {
    if (value || this.parent.isSubscription) return true;
    return false
  }),
  isSubscription: Yup.boolean().test('isCommission', 'At least one of Commission or Subscription must be true', function (value) {
    if (value || this.parent.isCommission) return true;
    return false
  }),

  longPickUpFee: Yup.number()
    .typeError('Long pick up fee must be a number')
    .positive('Long pick up fee must be a positive number')
    .min(0, 'Commission fee must be a positive number or zero')
    .required('Long pick up fee is required'),

  description: Yup.string()
    .trim()
    .max(100, "Description must be at most 100 characters"),
  airportPickupFee: Yup.number().typeError("Must be a number").required("Required"),
  airportDropFee: Yup.number().typeError("Must be a number").required("Required"),
  fleetCommission: Yup.number()
    .typeError('Commission fee must be a number')
    .positive('Commission fee must be a positive number')
    .required('Commission fee is required')
    .min(0, 'Commission fee must be a positive number or zero'),

})

export const defaultCategoryValidationSchema = Yup.object().shape({
  category: Yup.string().trim().required('Category is required'),

  baseRate: Yup.number()
    .typeError('Base rate must be a number')
    .positive('Base rate must be a positive number')
    .required('Base rate is required'),

  perMiles: Yup.number()
    .typeError('Per Km must be a number')
    .positive('Per Km must be a positive number')
    .required('Per Km is required'),

  perMinute: Yup.number()
    .typeError('Per minute must be a number')
    .positive('Per minute must be a positive number')
    .required('Per minute is required'),

  surcharge: Yup.number()
    .typeError('Surcharge must be a number')
    .required('Surcharge is required'),

  rideBookingFee: Yup.number()
    .typeError('Ride booking fee must be a number')
    // .positive('Ride booking fee must be a positive number')
    .min(0, 'Ride booking fee must be a positive number')
    .required('Ride booking fee is required'),
  description: Yup.string()
    .trim()
    .max(100, "Description must be at most 100 characters"),

  waitFee: Yup.number()
    .typeError('Wait fee must be a number')
    // .positive('Wait fee must be a positive number')
    .min(0, 'Wait fee must be a positive number')
    .required('Wait fee is required'),

  cancellationFee: Yup.number()
    .typeError('Cancellation fee must be a number')
    .min(0, 'Cancellation fee must be a positive number')
    // .positive('Cancellation fee must be a positive number')
    .required('Cancellation fee is required'),

  platformFee: Yup.number()
    .typeError('Platform fee must be a number')
    .min(0, 'Platform fee must be a positive number')
    // .positive('Platform fee must be a positive number')
    .required('Platform fee is required'),

  otherStopFee: Yup.number()
    .typeError('Other stop fee must be a number')
    .min(0, 'Other stop fee must be a positive number')
    // .positive('Other stop fee must be a positive number')
    .required('Other stop fee is required'),

  cityTax: Yup.number()
    .typeError('City Tax(%)/ Levy Fee must be a number')
    .min(0, 'City Tax(%)/ Levy Fee must be a positive number')
    // .positive('City Tax(%)/ Levy Fee must be a positive number')
    .required('City Tax(%)/ Levy Fee is required'),

  weather: Yup.number()
    .typeError('Weather must be a number')
    .min(0, 'Weather must be a positive number')
    // .positive('Weather must be a positive number')
    .required('Weather is required'),

  // noOfRides: Yup.number()
  //   .typeError('Number of rides must be a number')
  //   .integer('Number of rides must be an integer'),

  isCommission: Yup.boolean().test('isCommission', 'At least one of Commission or Subscription must be true', function (value) {
    if (value || this.parent.isSubscription) return true;
    return false
  }),
  isSubscription: Yup.boolean().test('isCommission', 'At least one of Commission or Subscription must be true', function (value) {
    if (value || this.parent.isCommission) return true;
    return false
  }),
  taxType: Yup.string()
    .required('Tax type is required'),
  airportPickupFee: Yup.number().typeError("Must be a number").required("Required"),
  airportDropFee: Yup.number().typeError("Must be a number").required("Required"),


  longPickUpFee: Yup.number()
    .typeError('Long pick up fee must be a number')
    .positive('Long pick up fee must be a positive number')
    .min(0, 'Commission fee must be a positive number or zero')
    .required('Long pick up fee is required'),

  order: Yup.number()
    .typeError('Order must be a number')
    .positive('Order must be a positive number')
    .min(0, 'Order must be a positive number or zero')
    .required('Order is required'),
  seat: Yup.number()
    .typeError('Seat must be a number')
    .positive('Seat must be a positive number')
    .min(0, 'Seat must be a positive number or zero')
    .required('Seat is required'),
});

export const ridesInitialValue = {
  make: "",
  model: "",
  categoryId: "",
  // seat: '',

}

export const ridesValidationSchema = Yup.object().shape({
  make: Yup.string().trim().required('Make is required'),
  model: Yup.string().trim().required('Model is required'),
  categoryId: Yup.number().required('Category is required'),
  seat: Yup.number().typeError("Seat must be a number")

})

export const cuisineOutletInitialValue = {
  // cityId: "",
  // countryId: "",
  name: "",
  image: ""
}

export const cuisineOutletValidationSchema = Yup.object().shape({
  // cityId: Yup.mixed().required('city is required'),
  // countryId: Yup.mixed().required('country is required'),
  name: Yup.string().trim().required('Name is required'),
  image: Yup.string().trim().required('Image is required'),
});

export const cityInitialValue = {
  cityName: "",
  place_id: "",
  cityTax: ""
}

export const cityValidationSchema = Yup.object().shape({
  cityName: Yup.string().trim().required('Name is required'),
  place_id: Yup.string().trim().required('place_id is required'),
  cityTax: Yup.number()
    .typeError('Tax must be a number')
    .positive('Tax must be a positive number')
    .required('Tax is required')
});

export const surchargePeriodInitialValue = {
  isEnabled: true,
  periodName: "",
  to: "",
  from: "",
  multiplier: "",
  // cityId: "",
  // countryId: "",
}

export const surchargePeriodValidationSchema = Yup.object().shape({
  periodName: Yup.string().trim().required('Name is required'),
  to: Yup.string().trim().required('To is required'),
  from: Yup.string().trim().required('From is required'),
  multiplier: Yup.number()
    .typeError('Tax must be a number')
    .positive('Tax must be a positive number')
    .required('Tax is required'),
  // cityId: Yup.mixed().required('city is required'),
  // countryId: Yup.mixed().required('country is required'),
});

export const bonusInitialValue = {
  name: "",
  noOfTrips: "",
  duration: "",
  from: "",
  to: "",
  minimumRating: "",
  amount: "",
  bonusFor: "",
  // minRideChargesForBonus: ""
}

export const bonusValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required'),
  noOfTrips: Yup.number()
    .typeError('No of Trips must be a number')
    .positive('No of Trips must be a positive number')
    .required('No of Trips is required'),
  duration: Yup.object().shape({
    value: Yup.string().required('Duration is required'),
    label: Yup.string().required('Duration is required'),
  }),
  minimumRating: Yup.number()
    .typeError('Minimum Rating must be a number')
    // .positive('Minimum Rating must be a positive number')
    .min(0, 'Minimum Rating must be a positive number')
    .max(5, 'Minimum Rating must be less than or equal to 5')
    .required('Minimum Rating is required'),
  amount: Yup.number()
    .typeError('Amount must be a number')
    .positive('Amount must be a positive number')
    .required('Amount is required'),
  // minRideChargesForBonus: Yup.number()
  //   .typeError('Min ride charge must be a number')
  //   .positive('Min ride charge must be a positive number')
  //   .required('Min ride charge is required'),
  from: Yup.string().test('from', 'From is required', function (value) {
    const { duration } = this.parent;
    if (duration && duration.value === 'period') {
      return !!value;
    }
    return true;
  }),
  to: Yup.string().test('to', 'To is required', function (value) {
    const { duration } = this.parent;
    if (duration && duration.value === 'period') {
      return !!value;
    }
    return true;
  }),
});

export const bonusWithdrawalLimitValidationSchema = Yup.object().shape({
  withdrawalLimit : Yup.number().required("withdrawal Limit is required")
})


export const discountInitialValue = {
  cityId: "",
  countryId: "",
  discount: "",
  from: "",
  to: ""
  // noOfTrips: "",
}

export const discountValidationSchema = Yup.object().shape({
  cityId: Yup.mixed().required('city is required'),
  from: Yup.date().required('from is required'),
  to: Yup.date().required('from is required'),
  countryId: Yup.mixed().required('country is required'),
  // noOfTrips: Yup.number()
  //   .typeError('No of Trips must be a number')
  //   .positive('No of Trips must be a positive number')
  //   .required('No of Trips is required'),
  discount: Yup.number()
    .typeError('Discount must be a number')
    .positive('Discount must be a positive number')
    .required('Discount is required'),
});

export const notificationInitialValue = {
  cityId: "",
  countryId: "",
  title: "",
  body: "",
}

export const notificationValidationSchema = Yup.object().shape({
  cityId: Yup.mixed().required('city is required'),
  countryId: Yup.mixed().required('country is required'),
  title: Yup.string().trim().required('Title is required'),
  body: Yup.string().trim().required('body is required'),
});

export const sentNotificationValidationSchema = Yup.object().shape({
  type: Yup.mixed().required('type is required'),
  partnerType: Yup.object()
    .nullable()
    .when("type", {
      is: (type) => type?.value === "partnerUser",
      then: (schema) => schema.required("partner type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
});


export const minimumChargesBonusInitialValue = {
  minRideChargesForBonus: 0
}

export const minimumChargesBonusInitialValueSchema = Yup.object().shape({
  minRideChargesForBonus: Yup.number()
    .typeError('Amount must be a number')
    .min(0, 'Amount must be a positive number')
    .required('Amount is required')
});

export const subscriptionDriverInitialValue = {
  name: "",
  duration: "",
  amount: ""
}

export const subscriptionDriverValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required'),
  duration: Yup.object().shape({
    value: Yup.string().required('Duration is required'),
    label: Yup.string().required('Duration is required'),
  }),
  amount: Yup.number()
    .typeError('Amount must be a number')
    .positive('Amount must be a positive number')
    .required('Amount is required'),
});

export const subscriptionFeeInitialValue = {
  subscriptionFee: 0,
  commissionFee: 0,
}

export const subscriptionFeeValidationSchema = Yup.object().shape({
  subscriptionFee: Yup.number()
    .typeError('subscription Fee must be a number')
    .min(0, 'subscription Fee must be a positive number or zero')
    .required('subscription Fee is required'),
  commissionFee: Yup.number()
    .typeError('commission Fee must be a number')
    .min(0, 'commission Fee must be a positive number or zero')
    .required('commission Fee is required'),
});

export const addCountryAndCityInitailValue = {
  name: ""
}

export const addCountryAndCityValidationSchema = Yup.object().shape({
  name: Yup.mixed().required('required'),
});


export const SosInitialValue = {
 name:"",
 phone:""
}

export const SosValidationSchema = Yup.object().shape({
  name: Yup.mixed().required('required'),
  phone: Yup.string().trim().required('required'),
});

export const addAdminInitialValues = {
  type: "add",
  firstName: "",
  lastName: "",
  email: "",
  country: "",
  password: "",
  role: ""
}

export const addAdminInitialValuesValidationSchema = Yup.object().shape({
  type: Yup.string().trim().required('required'),
  firstName: Yup.string().trim().required('required'),
  lastName: Yup.string().trim().required('required'),
  email: Yup.string().email('Invalid email format').required('required'),
  password: Yup.string().trim().required('required'),
  role: Yup.mixed().required('required'),
  country: Yup.object().shape({
    label: Yup.string().required('required'),
    value: Yup.string().required('required'),
  })
});

export const packageDefaultCategoryValidation = Yup.object().shape({
  category: Yup.string().trim().required('Category is required'),

  baseRate: Yup.number()
    .typeError('Base rate must be a number')
    .positive('Base rate must be a positive number')
    .required('Base rate is required'),

  perMiles: Yup.number()
    .typeError('Per Km must be a number')
    .positive('Per Km must be a positive number')
    .required('Per Km is required'),

  perMinute: Yup.number()
    .typeError('Per minute must be a number')
    .required('Per minute is required'),

  rideBookingFee: Yup.number()
    .typeError('Ride booking fee must be a number')
    .required('Ride booking fee is required'),

  cancellationFee: Yup.number()
    .typeError('Cancellation fee must be a number')
    .required('Cancellation fee is required'),

  platformFee: Yup.number()
    .typeError('Platform fee must be a number')
    .required('Platform fee is required'),

  cityTax: Yup.number()
    .typeError('City Tax(%)/ Levy Fee must be a number')
    .required('City Tax(%)/ Levy Fee is required'),
    
  taxType: Yup.string()
    .required('Tax type is required'),

  weather: Yup.number()
    .typeError('Weather must be a number')
    .required('Weather is required'),

  noOfRides: Yup.number()
    .typeError('Number of rides must be a number')
    .integer('Number of rides must be an integer'),

});

export const rentalsDefaultCategoryValidation = Yup.object().shape({
  category: Yup.string().trim().required('Category is required'),

  cancellationFee: Yup.number()
    .typeError('Cancellation fee must be a number')
    .positive('Cancellation fee must be a positive number')
    .required('Cancellation fee is required'),

  platformFee: Yup.number()
    .typeError('Platform fee must be a number')
    .positive('Platform fee must be a positive number')
    .required('Platform fee is required'),

});

export const adminBannerInitialValues = {
  description: "",
  image: "",
}

export const adminBannerInitialValuesValidationSchema = Yup.object().shape({
  description: Yup.string().trim(),
  image: Yup.mixed().required('Image is required'),
});

export const rateInitialValues = {
  commissionFee: "",
  discount: "",
  id: "",
}

export const rateValidationSchema = Yup.object().shape({
  commissionFee: Yup.number()
    .typeError('Commission fee must be a number')
    .min(0, 'Commission fee must be a positive number')
    .required('Commission fee is required'),
  discount: Yup.number()
    .typeError('Discount must be a number')
    .min(0, 'Discount must be a positive number')
    .required('Discount is required'),
  id: Yup.string().trim(),
});

export const rateRestaurantInitialValues = {
  deliveryFee: "",
  tax: "",
  discount: "",
  id: "",
  discountOnOff: false
}

export const rateRestaurantValidationSchema = Yup.object().shape({
  // deliveryFee: Yup.number()
  //  .typeError('Delivery fee must be a number')
  //  .positive('Delivery fee must be a positive number')
  //  .required('Delivery fee is required'),
  tax: Yup.number()
    .typeError('tax must be a number')
    .positive('tax must be a positive number')
    .required('tax is required'),
  discount: Yup.number()
    .typeError('discount must be a number')
    .positive('discount must be a positive number')
    .required('discount is required'),
  id: Yup.string().trim(),
  discountOnOff: Yup.boolean()
});

export const referralInitialValues = {
  minTrips: 0,
  minReferral: 0,
  minTripCharges: 0,
  referralPrice: 0,
  refereePrice: 0,
  referralOnOff: false,
  id: "",
  validRewardDays: 0,
  validDays: 0,
  countryId: null,
  cityId: [],
  firstNoOf: 0,
  signupMinTrips: 0,
  signupMinTripCharges: 0,
  signupRewardPrice: 0,
  signupValidDays: 0,
  signupValidRewardDays: 0,
  signupOnOff: false,
  from: "",
  to: "",
  minTripsRider: 0,
  minReferralRider: 0,
  referralPriceRider: 0,
  refereePriceRider: 0,
  minTripChargesRider: 0,
  referralOnOffRider: false,
  validRewardDaysRider: 0,
  validDaysRider: 0,
  countryIdRider: "",
  cityIdRider: "",
  firstNoOfRider: 0,
  signupMinTripsRider: 0,
  signupMinTripChargesRider: 0,
  signupRewardPriceRider: 0,
  signupValidDaysRider: 0,
  signupValidRewardDaysRider: 0,
  signupOnOffRider: false,
  fromRider: "",
  toRider: "",
  fromReferral: "",
  toReferral: "",
  fromReferralRider: "",
  toReferralRider: "",
  rewardUsage: 0,
}

export const referralValidationSchema = Yup.object().shape({
  minTrips: Yup.number()
    .typeError('mit trip fee must be a number')
    .min(0, 'mit trip fee must be a positive number')
    .required('mit trip fee is required'),
  minReferral: Yup.number()
    .typeError('min referral must be a number')
    .min(0, 'min referral must be a positive number')
    .required('min referral is required'),
  minTripCharges: Yup.number()
    .typeError('min trip charges must be a number')
    .min(0, 'min trip charges must be a positive number')
    .required('min trip charges is required'),
  referralPrice: Yup.number()
    .typeError('reward price must be a number')
    .min(0, 'reward price must be a positive number')
    .required('reward price is required'),
  refereePrice: Yup.number()
    .typeError('reward price must be a number')
    .min(0, 'reward price must be a positive number')
    .required('reward price is required'),
  id: Yup.string().trim(),
  referralOnOff: Yup.boolean(),
  validRewardDays: Yup.number()
    .typeError('valid reward days must be a number')
    .min(0, 'valid reward days must be a positive number')
    .required('valid reward days is required'),
  validDays: Yup.number()
    .typeError('valid days must be a number')
    .min(0, 'valid days must be a positive number')
    .required('valid days is required'),
  firstNoOf: Yup.number()
    .typeError('First no of must be a number')
    .min(0, 'First no of must be a positive number')
    .required('First no of is required'),
  countryId: Yup.mixed().required("Country is required"),
  cityId: Yup.mixed()
    .transform((value, originalValue) => {
      if (!Array.isArray(originalValue)) {
        return originalValue ? [originalValue] : [];
      }
      return originalValue;
    })
    .test("min-one", "At least one city is required", (value) => {
      return Array.isArray(value) && value.length > 0;
    })
    .required("city is required"),
  signupMinTrips: Yup.number()
    .typeError('signup mit trip fee must be a number')
    .min(0, 'signup mit trip fee must be a positive number')
    .required('signup mit trip fee is required'),
  signupMinTripCharges: Yup.number()
    .typeError('signup min trip charges must be a number')
    .min(0, 'signup min trip charges must be a positive number')
    .required('signup min trip charges is required'),
  signupRewardPrice: Yup.number()
    .typeError('signup reward price must be a number')
    .min(0, 'signup reward price must be a positive number')
    .required('signup reward price is required'),
  signupValidDays: Yup.number()
    .typeError('signup valid days must be a number')
    .min(0, 'signup valid days must be a positive number')
    .required('signup valid days is required'),
  signupValidRewardDays: Yup.number()
    .typeError('signup valid reward days must be a number')
    .min(0, 'signup valid reward days must be a positive number')
    .required('signup valid reward days is required'),
  signupOnOff: Yup.boolean(),
  minTripsRider: Yup.number()
    .typeError('mit trip fee must be a number')
    .min(0, 'mit trip fee must be a positive number')
    .required('mit trip fee is required'),
  minReferralRider: Yup.number()
    .typeError('min referral must be a number')
    .min(0, 'min referral must be a positive number')
    .required('min referral is required'),
  minTripChargesRider: Yup.number()
    .typeError('min trip charges must be a number')
    .min(0, 'min trip charges must be a positive number')
    .required('min trip charges is required'),
  referralPriceRider: Yup.number()
    .typeError('reward price must be a number')
    .min(0, 'reward price must be a positive number')
    .required('reward price is required'),
  refereePriceRider: Yup.number()
    .typeError('reward price must be a number')
    .min(0, 'reward price must be a positive number')
    .required('reward price is required'),
  referralOnOffRider: Yup.boolean(),
  validRewardDaysRider: Yup.number()
    .typeError('valid reward days must be a number')
    .min(0, 'valid reward days must be a positive number')
    .required('valid reward days is required'),
  validDaysRider: Yup.number()
    .typeError('valid days must be a number')
    .min(0, 'valid days must be a positive number')
    .required('valid days is required'),
  firstNoOfRider: Yup.number()
    .typeError('First no of must be a number')
    .min(0, 'First no of must be a positive number')
    .required('First no of is required'),
  signupMinTripsRider: Yup.number()
    .typeError('signup mit trip fee must be a number')
    .min(0, 'signup mit trip fee must be a positive number')
    .required('signup mit trip fee is required'),
  signupMinTripChargesRider: Yup.number()
    .typeError('signup min trip charges must be a number')
    .min(0, 'signup min trip charges must be a positive number')
    .required('signup min trip charges is required'),
  signupRewardPriceRider: Yup.number()
    .typeError('signup reward price must be a number')
    .min(0, 'signup reward price must be a positive number')
    .required('signup reward price is required'),
  signupValidDaysRider: Yup.number()
    .typeError('signup valid days must be a number')
    .min(0, 'signup valid days must be a positive number')
    .required('signup valid days is required'),
  signupValidRewardDaysRider: Yup.number()
    .typeError('signup valid reward days must be a number')
    .min(0, 'signup valid reward days must be a positive number')
    .required('signup valid reward days is required'),
  signupOnOffRider: Yup.boolean(),
  rewardUsage: Yup.number()
    .typeError('Reward Usage must be a number')
    .min(0, 'Reward Usage must be a positive number')
    .required("reward usage is required")
});

export const globalRestaurantServiceFeeInitialValues = {
  retaurantServiceFee: "",
  restaurentServiceFeeOnOff: false,
  minWithdrawalAmount: "",
  withdrawalCharge: ""
}

export const globalRestaurantServiceFeeValidationSchema = Yup.object().shape({
  retaurantServiceFee: Yup.number()
    .typeError('service fee must be a number')
    .min(0, "must be positive"),
  minWithdrawalAmount: Yup.number()
    .typeError('must be a number')
    .min(0, "must be positive"),
  withdrawalCharge: Yup.number()
    .typeError('must be a number')
    .min(0, "must be positive"),

  restaurentServiceFeeOnOff: Yup.boolean()
});

export const salesAgentInitialValues = {
  rewardPercentage: 0,
  rewardExpiryDate: "",
  id: "",
}

export const salesAgentRatesValidationSchema = Yup.object().shape({
  rewardPercentage: Yup.number()
    .typeError('Delivery fee must be a number')
    .required('Delivery fee is required'),
  rewardExpiryDate: Yup.mixed(),
  id: Yup.string().trim(),
});

export const driverRateIntialValue = {
  // minDriverWalletBalance: "",
  minWithdrawalAmount: "",
  withdrawalCharge: ""
}
export const driverRateValidationSchema = Yup.object().shape({
  // minDriverWalletBalance: Yup.number()
  //   .typeError('Min balance must be a number')
  //   .min(0, 'Min balance must be a positive number')
  //   .required('Min balance is required'),
  minWithdrawalAmount: Yup.number()
    .typeError('Min balance must be a number')
    .min(0, 'Min balance must be a positive number')
    .required('Min balance is required'),
  withdrawalCharge: Yup.number()
    .typeError('charge must be a number')
    .min(0, 'charge must be a positive number')
    .required('charge is required')
});

export const rentalChargesIntialValue = {
  minWithdrawalAmount: "",
  withdrawalCharge: ""
}

export const rentalChargesValidationSchema = Yup.object().shape({
  minWithdrawalAmount: Yup.number()
    .typeError('Min balance must be a number')
    .min(0, 'Min balance must be a positive number')
    .required('Min balance is required'),
  withdrawalCharge: Yup.number()
    .typeError('charge must be a number')
    .min(0, 'charge must be a positive number')
    .required('charge is required')
});
export const selsChargesIntialValue = {
  minWithdrawalAmount: "",
  withdrawalCharge: ""
}

export const selsChargesValidationSchema = Yup.object().shape({
  minWithdrawalAmount: Yup.number()
    .typeError('Min balance must be a number')
    .min(0, 'Min balance must be a positive number')
    .required('Min balance is required'),
  withdrawalCharge: Yup.number()
    .typeError('charge must be a number')
    .min(0, 'charge must be a positive number')
    .required('charge is required')
});

export const termAndConditonsInitailValue = {
  content: "",
  type: ""
}

export const termAndConditonsValidationSchema = Yup.object().shape({
  content: Yup.string().required('required'),
});

export const blogInitialValues = {
  heading: "",
  content: "",
  image: "",
  isPublish: false,
}

export const blogValidationSchema = Yup.object().shape({
  heading: Yup.string().trim().required('Heading is required'),
  content: Yup.string().trim().required('Content is required'),
  image: Yup.string().trim().required('Image is required'),
});

export const pressInitialValues = {
  heading: "",
  content: "",
  image: "",
  isPublish: false,
  contentType: "press"
}

export const learningInitialValues = {
  type: "",
  title: "",
  description: "",
  additionalMaterial: "",
  answers: "",
  notes: "",
  isPublish: true,
  thumbnail: "",
  video: "",
  content: "",
  language:""
}


export const learningValidationSchema = Yup.object().shape({
  title: Yup.string().trim().required('Title is required'),
  type: Yup.string().trim().required('Type is required'),
  description: Yup.string().trim().test(
    'description-required-if-video',
    'Description is required',
    function (value) {
      const { type } = this.parent;
      return type !== 'video' || (value && value.trim() !== '');
    }
  ),

  additionalMaterial: Yup.string().trim().test(
    'additionalMaterial-required-if-video',
    'Additional material is required',
    function (value) {
      const { type } = this.parent;
      return type !== 'video' || (value && value.trim() !== '');
    }
  ),

  answers: Yup.string().trim().test(
    'answers-required-if-video',
    'Answers are required',
    function (value) {
      const { type } = this.parent;
      return type !== 'video' || (value && value.trim() !== '');
    }
  ),

  notes: Yup.string().trim().test(
    'notes-required-if-video',
    'Notes are required',
    function (value) {
      const { type } = this.parent;
      return type !== 'video' || (value && value.trim() !== '');
    }
  ),
  // isPublish: Yup.boolean().required('Publish status is required'),
  thumbnail: Yup.string().trim().required('Thumbnail is required'),

  video: Yup.string().trim().test(
    'video-required-if-video',
    'Video is required',
    function (value) {
      const { type } = this.parent;
      return type !== 'video' || (value && value.trim() !== '');
    }
  ),
  content: Yup.string().trim().test(
    'content-required-if-article',
    'Content is required',
    function (value) {
      const { type } = this.parent;
      return type !== 'article' || (value && value.trim() !== '');
    }
  ),
  language:Yup.string().required("language is required")
});



export const supportInitialValues = {
  question: "",
  answer: "",
  userType: '',

}

export const supportValidationSchema = Yup.object().shape({
  question: Yup.string().trim().required('question is required'),
  answer: Yup.string().trim().required('answer is required'),
  userType: Yup.string().required('For which is required'),

});

export const jobInitialValue = {
  "title": "",
  "jobType": "",
  "package": "",
  "email": "",
  "countryId": null,
  "cityId": null,
  "experience": "",
  "education": "",
  "description": "",
  "responsibilities": "",
  // "logo": "",
  "isDisclosed": false,
  "isOpen": true,
  categoryId: ""
}


export const jobValidationSchema = Yup.object().shape({
  title: Yup.string().required('Job title is required'),
  jobType: Yup.string().required('Job type is required'),
  package: Yup.string().required('Package is required'),
  countryId: Yup.object().required('Country is required'),
  cityId: Yup.object().required('City is required'),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  // .matches(/^\d+(\.\d{1,2})?$/, 'Package must be a valid number'),
  experience: Yup.string().required('Experience is required'),
  education: Yup.string().required('Education qualification is required'),
  description: Yup.string().required('Job description is required'),
  categoryId: Yup.string().required('Category is required'),
  responsibilities: Yup.string().required('Responsibilities are required'),
  // skills: Yup.string().required('Skills are required'),
  // logo: Yup.string().required('Logo is required'),
  isDisclosed: Yup.boolean(),
  isOpen: Yup.boolean(),
});

export const jobCategoryIntialValue = {
  "categoryName": "",
  "description": "",
}
export const jobCategoryValidationSchema = Yup.object().shape({
  categoryName: Yup.string().required('Name is required'),
});

export const bankDetailsInitialValue = {
  "bankName": "",
  "accountNo": "",
  "accountType": "",
  "Ifsc": "",
}


export const bankDetailsValidationSchema = Yup.object().shape({
  bankName: Yup.string().trim().required('required'),
  accountNo: Yup.string().trim().required('required'),
  accountType: Yup.string().trim().required('required'),
  Ifsc: Yup.string().trim().required('required'),
});


export const vehicleInitialValue = {
  "categoryId": "",
  "modelId": "",
  "makeId": "",
  "year": "",
  "color": "",
  "licenseNo": "",
  "vehicleNumber": "",
  "vehicleCertificate": "",
  "vehicleCertificateValidUpto": "",
  "vehicleInsurance": "",
  "insuranceCertificateValidUpto": "",
}


export const vehicleValidationSchema = Yup.object().shape({
  categoryId: Yup.object().test('categoryId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  modelId: Yup.object().test('modelId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  makeId: Yup.object().test('makeId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  year: Yup.string().trim().required('required'),
  color: Yup.string().trim().required('required'),
  licenseNo: Yup.string().trim().required('required'),
  vehicleNumber: Yup.string().trim().required('required'),
  vehicleCertificate: Yup.string().trim().required('required'),
  vehicleCertificateValidUpto: Yup.string().trim().required('required'),
  vehicleInsurance: Yup.string().trim().required('required'),
  insuranceCertificateValidUpto: Yup.string().trim().required('required'),
});

export const rentalVehicleInitialValue = {
  "categoryId": "",
  "modelId": "",
  "makeId": "",
  "year": "",
  "color": "",
  "vehicleNumber": "",
  "vehicleCertificate": "",
  "vehicleCertificateValidUpto": "",
  "vehicleInsurance": "",
  "insuranceCertificateValidUpto": "",
}

export const rentalVehicleValidationSchema = Yup.object().shape({
  categoryId: Yup.object().test('categoryId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  modelId: Yup.object().test('modelId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  makeId: Yup.object().test('makeId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  year: Yup.string().trim().required('required'),
  color: Yup.string().trim().required('required'),
  vehicleNumber: Yup.string().trim().required('required'),
  vehicleCertificate: Yup.string().trim().required('required'),
  vehicleCertificateValidUpto: Yup.string().trim().required('required'),
  vehicleInsurance: Yup.string().trim().required('required'),
  insuranceCertificateValidUpto: Yup.string().trim().required('required'),
});

export const profileDetailsInitialValue = {
  name: "",
  alternateMobile: "",
  email: "",
  NIN: "",
  permanentAddress: "",
  gender: "",
  city: "",
  country: "",
  profileImage: "",
  isAvailable: null // or { label: "No", value: false } if you want default selected
}


export const profileValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required('required'),
  alternateMobile: Yup.string().trim().required('required'),
  email: Yup.string().trim().email("Must be vaild email").required('required'),
  NIN: Yup.string().trim().required('required'),
  permanentAddress: Yup.string().trim().required('required'),
  gender: Yup.object().test('makeId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  profileImage: Yup.string().trim().required('required'),
  isAvailable: Yup.object().test('isAvailable', 'required', function (value) {
    const { role } = this.parent
    console.log("role", role);
    if (role?.[0] != "driver") return true
    if (value?.value === true || value?.value === false) return true;
    return false;
  }),

});

export const salesAgentRateInitialValues ={
  type:"",
  commission:"",
  from:"",
  to:"",
  reward:false,
  id:""
}

export const salesAgentValidationSchema = Yup.object().shape({
  type: Yup.string().trim().required('type is required'),
  commission: Yup.string().trim().required('commission  is required'),
  from: Yup.string().trim().required('from is required'),
  to: Yup.string().trim().required('to is required'),
  reward : Yup.boolean().required('reward is required'),
});

export const busOperatorInitalValues = {
  companyName: "",
  displayName: "",
  // TIN: "",
  companyLogo: "",
}

export const busOperatorValidationSchema = Yup.object().shape({
  companyName: Yup.string().trim().required('Company name is required'),
  displayName: Yup.string().trim().required('Display name is required'),
  // TIN: Yup.string().trim().required('TIN is required'),
  companyLogo: Yup.string().trim().required('Company logo is required'),
});


export const restaurantInitialValue = {
  name: "",
  address: "",
  openingTime: "",
  closingTime: "",
  totalEarnings: "",
  days: "",
  deliveryRestaurantTimingType: "",
  establishmentType: "",
  isOnline: "",
  secondarycontactNo: "",
  secondarycontactNoType: "",
  status: "",
  contactNo: "",
  menuImage: "",
  menuImageForOnlineOrders: "",
  restaurantImage: "",
};

export const restaurantValidationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  address: Yup.string().required('Required'),
  openingTime: Yup.string().required('Required'),
  closingTime: Yup.string().required('Required'),
  totalEarnings: Yup.string().required('Required'),
  days: Yup.array()
    .of(Yup.object().required("Each day is required"))
    .min(1, "At least one day must be selected")
    .required("Required"),
  deliveryRestaurantTimingType: Yup.string().required('Required'),
  establishmentType: Yup.string().required('Required'),
  isOnline: Yup.string().required('Required'),
  secondarycontactNo: Yup.string().required('Required'),
  secondarycontactNoType: Yup.string().required('Required'),
  status: Yup.object().test('makeId', 'required', function (value) {
    if (value?.value) return true;
    return false
  }),
  contactNo: Yup.string().required('Required'),
  menuImage: Yup.string().required('Required'),
  menuImageForOnlineOrders: Yup.string().required('Required'),
  restaurantImage: Yup.string().required('Required'),
});

export const documentInitialValues = {
  panNumber: "",
  panApprovalStatus: "",
  panImage: "",

  gstNumber: "",
  gstApprovalStatus: "",
  gstCertificate: "",

  FSSAICertificateNo: "",
  FSSAIExpiredDate: "",
  fssaiApprovalStatus: "",
  FSSAICertificate: "",
};

export const documentValidationSchemas = {
  "Pan card": Yup.object().shape({
    panNumber: Yup.string().trim().required("PAN number is required"),
    panApprovalStatus: Yup.string().trim().required("Status is required"),
    panImage: Yup.string().trim().required("File is required"),
  }),

  "GST": Yup.object().shape({
    gstNumber: Yup.string().trim().required("GST number is required"),
    gstApprovalStatus: Yup.string().trim().required("Status is required"),
    gstCertificate: Yup.string().trim().required("File is required"),
  }),

  "FSSAI Certificate": Yup.object().shape({
    FSSAICertificateNo: Yup.string().trim().required("Certificate Number is required"),
    FSSAIExpiredDate: Yup.string().trim().required("Valid Upto date is required"),
    fssaiApprovalStatus: Yup.string().trim().required("Status is required"),
    FSSAICertificate: Yup.string().trim().required("File is required"),
  }),
};

export const menuItemInitialValues = {
  index: "",
  name: "",
  price: "",
  description: "",
  servingSize: "",
  menuItemCategory: { label: "", value: "" },
  cuisine: { label: "", value: "" },
  isActive: "",
  createdAt: "",
};


export const menuItemValidationSchema = Yup.object().shape({
  // index: Yup.string().required("S.No is required"),
  // name: Yup.string().required("Name is required"),
  // price: Yup.number().typeError("Price must be a number").required("Price is required"),
  // description: Yup.string().required("Description is required"),
  // servingSize: Yup.string().required("Serving size is required"),
  // menuItemCategory: Yup.object({
  //   label: Yup.string().required(),
  //   value: Yup.mixed().required("Category is required"),
  // }).required("Category is required"),
  // cuisine: Yup.object({
  //   label: Yup.string().required(),
  //   value: Yup.mixed().required("Cuisine is required"),
  // }).required("Cuisine is required"),
  // isActive: Yup.string().required("Status is required"),
  // createdAt: Yup.string().required("Created date is required"),
});


// bus operator start
export const busOpCommissionInitialValues = {
  id: "",
  commission: "",
  discount: "",
  discountOnOff: false
}

export const busOpCommissionlidationSchema = Yup.object().shape({
  commission: Yup.number()
    .typeError('commission must be a number')
    .positive('commission must be a positive number')
    .min(0, "Minimum zero")
    .required('commission is required'),
  discount: Yup.number()
    .typeError('discount must be a number')
    .positive('discount must be a positive number')
    .min(0, "Minimum zero")
    .required('discount is required'),
  id: Yup.string().trim(),
  discountOnOff: Yup.boolean()
});

export const globalBusOpFeeInitialValues = {
  serviceFee: "",
  serviceFeeOnOff: false,
  minWithdrawalAmount: "",
  withdrawalCharge: ""
}

export const globalBusOpFeeValidationSchema = Yup.object().shape({
  serviceFee: Yup.number()
    .typeError('service fee must be a number')
    .min(0, "must be positive"),
  minWithdrawalAmount: Yup.number()
    .typeError('must be a number')
    .min(0, "must be positive"),
  withdrawalCharge: Yup.number()
    .typeError('must be a number')
    .min(0, "must be positive"),

  serviceFeeOnOff: Yup.boolean()
});
// bus operator end

export const jobApplicationInitialValues = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  resume: "",
  job: "",
  status: ""
}

export const jobApplicationValidationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('required'),
  lastName: Yup.string().trim().required('required'),
  phone: Yup.string().trim().required('required'),
  email: Yup.string().email('Invalid email format').required('required'),
  // resume: Yup.string().trim().required('required'),
  job: Yup.string().required('required'),
  status: Yup.string().required("required")
});


export const fleetOwnerDriverInitialValue = {
  Name: "",
  Phone: "",
  Gender: "",
  nin: "",
  // status:"",
};

export const fleetOwnerDriverValidationSchema = Yup.object().shape({
  // name: Yup.string()
  //   .required("Name is required"),

  // phone: Yup.string()
  //   .required("Phone number is required"),

  // gender: Yup.mixed()
  //   .required("Gender is required"),

  // NIN: Yup.string()
  //   .required("NIN is required"),

  // status: Yup.boolean()
  //   .required("Status is required")
});

export const busOperatorDriverInitialValues = {
  profileImg: "",
  firstName: "",
  lastName: "",
  phone: "",
  gender: ""
}

export const busOperatorDriverValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("fist name is required"),

  lastName: Yup.string()
    .required("last name is required"),

  phone: Yup.string()
    .required("Phone number is required"),

  gender: Yup.mixed()
    .required("Gender is required"),
})

export const busOperatorVehicleInitialValues = {
  busType: "",
  registrationNo: "",
  name: "",
  rcDocument: "",
  insuranceDocument: ""
}

export const busOperatorVehicleValidationSchema = Yup.object().shape({
  busType: Yup.string()
    .required("busType is required"),

  registrationNo: Yup.string()
    .required("registrationNo is required"),

  name: Yup.string()
    .required("name is required"),

  rcDocument: Yup.string()
    .required("rcDocument is required"),

  insuranceDocument: Yup.string()
    .required("insuranceDocument is required"),
})


export const newCustomerInitialValue = {
  type:'',
  phone:''
}

export const newCustomerValidationSchema = Yup.object({
  type: Yup.mixed().required("Type is required"),

  phone: Yup.string()
    .min(10, "Phone must be at least 10 digits")
    .max(15, "Phone must not exceed 15 digits")
    .required("Phone is required"),
});

export const weeklyMarkPaidInitialValues = {
  id: "",
  transactionId: "",
  mode: "",
  status: "pending",
  attachment: "",
}; 

export const weeklyMarkPaidValidationSchema = Yup.object().shape({
  id: Yup.string()
    .required("Withdrawal ID is required"),
  transactionId: Yup.string()
    .trim()
    .required("Transaction ID is required"),
  mode: Yup.string()
    .required("Payment mode is required"),
  status: Yup.string()
    .oneOf(["pending", "paid"], "Invalid status")
    .required("Status is required"),
  attachment: Yup.string()
    .required("Attachment is required"),
});